import React from 'react';
import { Button, Grid } from '@mui/material';
import Loading from 'components/Messages/Loading/Loading';
import Error from 'components/Messages/Error/Error';
import { ActivitiesContextProvider, useActivitiesContext } from '../Activities/activities.context';
import ReportsTable from './Table/Table';
import { StoresContextProvider } from 'pages/Stores/stores.context';
import { UsersContextProvider } from 'context/users.context';
import SectionHeader from 'components/SectionHeader/SectionHeader';
import ContentWrapper from 'components/StyledComponents/ContentWrapper';
import { Link } from 'react-router-dom';

const ReportsComponent = (): JSX.Element => {
  const { loading, error } = useActivitiesContext();

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <Error message='There was an error loading Reports' />;
  }

  const actions = (
    <Button component={Link} variant='contained' color='secondary' to={'/reports'}>
      Export Report Selection
    </Button>
  );

  return (
    <Grid container>
      <Grid item xs={12}>
        <SectionHeader title='Reports' actions={actions} pageHeader />
        <ContentWrapper>
          <ReportsTable />
        </ContentWrapper>
      </Grid>
    </Grid>
  );
};

const Reports = () => (
  <UsersContextProvider>
    <ActivitiesContextProvider>
      <StoresContextProvider>
        <ReportsComponent />
      </StoresContextProvider>
    </ActivitiesContextProvider>
  </UsersContextProvider>
);

export default Reports;
